import { faClockTwo } from '@rq-ratings/pro-solid-svg-icons'
import React from 'react'
import { Modal } from 'react-bootstrap'

import useAppDispatch from '../../../hooks/useAppDispatch'
import useAppSelector from '../../../hooks/useAppSelector'
import useMaxWidth from '../../../hooks/useMaxWidth'
import {
  selectReferralsImportHistorical,
  setIsOpen,
} from '../../../redux/slices/referralsImportHistorical'
import ImportHistoricalReferralsFlow from './ImportHistoricalReferralsFlow'

const ImportHistoricalReferralsModal: React.FC = () => {
  const isMaxWidthMd = useMaxWidth('md')
  const dispatch = useAppDispatch()
  const referralsImportHistoricalState = useAppSelector(
    selectReferralsImportHistorical,
  )

  const handleClose = () => {
    dispatch(setIsOpen(false))
  }

  const fullscreen =
    isMaxWidthMd ||
    (referralsImportHistoricalState.step === 'resolve-import'
      ? true
      : undefined)

  return (
    <ImportHistoricalReferralsFlow>
      {({ renderHeader, renderBody, renderFooter }) => (
        <Modal
          show={referralsImportHistoricalState.isOpen}
          fullscreen={fullscreen}
          centered
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <h2 className="mb-0">{renderHeader(faClockTwo)}</h2>
          </Modal.Header>

          <Modal.Body>{renderBody()}</Modal.Body>

          <Modal.Footer>{renderFooter()}</Modal.Footer>
        </Modal>
      )}
    </ImportHistoricalReferralsFlow>
  )
}

export default ImportHistoricalReferralsModal
